import { z } from "zod";
import { InteractiveTable } from "@vendor-app/app/_sharedComponents/InteractiveDataTable";

export namespace HomeTableColumns {
  // All possible columns across both tabs
  export const allColumnTypes = [
    "shopifyId",
    "upcomingOrderDate",
    "emailOrName",
    "email",
    "estimatedTotal",
    "items",
    "status",
    "createdDate",
    "sellingPlanId",
    "cancellationReason",
    "action",
  ] as const;

  export const typeSchema = z.enum(allColumnTypes);
  export type Column = z.infer<typeof typeSchema>;

  export const activeTabColumns: Column[] = [
    "shopifyId",
    "upcomingOrderDate",
    "emailOrName",
    "email",
    "estimatedTotal",
    "items",
    "status",
    "createdDate",
    "sellingPlanId",
  ];

  export const cancelledTabColumns: Column[] = [
    "shopifyId",
    "emailOrName",
    "email",
    "estimatedTotal",
    "items",
    "cancellationReason",
    "action",
  ];

  export const columnInfo: Record<Column, { title: string }> = {
    shopifyId: { title: "Subscription ID" },
    upcomingOrderDate: { title: "Upcoming order" },
    emailOrName: { title: "Customer" },
    email: { title: "Customer email" },
    estimatedTotal: { title: "Est. total" },
    items: { title: "Items" },
    status: { title: "Status" },
    createdDate: { title: "Created date" },
    sellingPlanId: { title: "Subscription program" },
    cancellationReason: { title: "Cancellation Reason" },
    action: { title: "Action Taken" },
  };

  export type SelectedColumn = InteractiveTable.SelectedColumn & {
    columnType: Column;
  };
}
